import LogoutIcon from '@mui/icons-material/Logout'
import { Avatar, ListItemIcon, Menu, MenuItem } from '@mui/material'
import { useOperationsStore } from '@operations/AppProvider'
import { equipmentService } from '@operations/services'
import { useTranslate } from '@tolgee/react'
import { PATHS, useAuth } from '@tom-ui/utils'
import { useState } from 'react'
import { useNavigate } from 'react-router'

interface Props {
  showSelectEquipment?: boolean
  showSelectGang?: boolean
  showCorrectPosition?: boolean
}
export const HeaderAvatar = ({
  showSelectEquipment,
  showSelectGang,
  showCorrectPosition,
}: Props) => {
  const { logout, user } = useAuth()
  const { t } = useTranslate()
  const navigate = useNavigate()
  const { appStore, equipmentOperatorLandingUIStore, equipmentOperatorWorkInstructionsUIStore } =
    useOperationsStore()

  const [anchorEl, setAnchorEl] = useState(null)

  const open = Boolean(anchorEl)
  const handleClick = (e: any) => {
    setAnchorEl(e.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const avatarInitials = user?.name
    ?.split(' ')
    .map(word => word.charAt(0))
    .join('')

  const handleCorrectPositionClick = () => {
    const url = PATHS.operators.operatorContainerTurnoversList.url
    navigate(url, { state: { key: window.location.href } })
  }

  const handleLogout = async () => {
    await equipmentService.logoutOperatorEquipment(user?.sub ?? '')
    await logout({ logoutParams: { returnTo: window.location.origin } })
  }

  return (
    <>
      <Avatar
        id='logout-menu'
        sx={{ bgcolor: '#C4CDD5', cursor: 'pointer', fontSize: '0.9rem' }}
        onClick={handleClick}
      >
        {avatarInitials}
      </Avatar>

      <Menu
        id='logout-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{ marginTop: 1 }}
      >
        {showSelectEquipment && (
          <MenuItem
            onClick={async () => {
              await appStore.removeAllAlerts()
              equipmentOperatorLandingUIStore.reset()
            }}
          >
            {t('selectEquipment', 'Select equipment')}
          </MenuItem>
        )}

        {showSelectGang && (
          <MenuItem
            onClick={async () => {
              await appStore.removeAllAlerts()
              equipmentOperatorWorkInstructionsUIStore.reset()
            }}
          >
            {t('selectGang', 'Select gang')}
          </MenuItem>
        )}

        {showCorrectPosition && (
          <MenuItem onClick={handleCorrectPositionClick}>
            {t('correctPosition', 'Correct position')}
          </MenuItem>
        )}

        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          {t('logout', 'Logout')}
        </MenuItem>
      </Menu>
    </>
  )
}
